import { createApplication } from '@aviv-unified-frontend/runtime/lifecycle';
import PlaceNotFoundError from '@/entities/errors/PlaceNotFoundError';
import { HttpError } from '@/entities/types/HttpError';
import { getPlaceBestDescendantUrl } from '@/helpers/geo/places';
import { getPricePageProps } from '@/helpers/getPricePageProps/getPricePageProps';
import { Logger } from '@/logger';
import { toLowerCase } from '@/middleware/lowercase';
import { redirect } from '@/middleware/redirect';
import { removeExtension } from '@/middleware/removeExtension';
import { removeTrailingSlash } from '@/middleware/removeTrailingSlash';
import { seoNameRedirect } from '@/middleware/seoNameRedirect';
import { accomodationTypeRedirect } from './middleware/accomodationTypeRedirect';
import { App } from './App';
const shellMiddleware = [
    removeTrailingSlash,
    removeExtension,
    redirect,
    seoNameRedirect,
    toLowerCase,
    accomodationTypeRedirect,
];
export default createApplication({
    id: 'app_pric',
    Component: App,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    async onServerRequest(request, response) {
        // Middleware
        for (const middleware of shellMiddleware) {
            await middleware(request, response);
        }
        // Get price page props
        const { pathname } = request.url;
        try {
            if (pathname.includes('gtm.js')) {
                Logger.warn(`url: ${request.url} contains GTM.JS, with these headers user agent: ${request.getHeader('user-agent')}, referrer: ${request.getHeader('referer')}, origin: ${request.getHeader('origin')}`, {
                    userAgent: request.getHeader('user-agent'),
                    referrer: request.getHeader('referer'),
                    origin: request.getHeader('origin'),
                });
            }
            const pricePageProps = await getPricePageProps(pathname);
            if (!pricePageProps) {
                return response.notFound();
            }
            if (!pricePageProps.pricePageContext.place.active) {
                const descendantUrl = await getPlaceBestDescendantUrl(pricePageProps.pricePageContext.place);
                if (descendantUrl) {
                    return response.redirect(descendantUrl, 301);
                }
                return response.notFound(410);
            }
            return {
                data: {
                    pricePageProps,
                    pathname,
                },
            };
        }
        catch (error) {
            const httpError = error;
            if (httpError instanceof PlaceNotFoundError) {
                return response.notFound();
            }
            if (httpError instanceof HttpError && httpError?.getStatusCode() >= 500) {
                Logger.error(`Get data rise an error: `, { error });
            }
            if (httpError instanceof HttpError && httpError?.getStatusCode() >= 400) {
                if (httpError?.getStatusCode() === 404) {
                    return response.notFound();
                }
            }
        }
    },
    logger: Logger,
});
